import React from "react";
import { computeApprovalPercent } from "../../utils/donationTrackingFormatters";

export default function DonationTrackingProgressSection({ summary, loading }) {
  if (loading) return null;

  const pending = Number(summary?.pending_donations || 0);
  const approved = Number(summary?.approved_donations || 0);
  const total = pending + approved;
  const pct = computeApprovalPercent(pending, approved);

  if (total === 0) {
    return (
      <section className="ddt-progress" aria-label="Verification progress">
        <p className="ddt-progress__label">Verification progress</p>
        <p className="ddt-page__hint" style={{ marginTop: "0.5rem" }}>
          No cash donations to track yet. When donations are recorded, their
          verification status will appear here.
        </p>
      </section>
    );
  }

  return (
    <section className="ddt-progress" aria-label="Verification progress">
      <div className="ddt-progress__top">
        <p className="ddt-progress__label">Payment verification progress</p>
        <span className="ddt-progress__pct">{pct}% approved</span>
      </div>
      <div className="ddt-progress__bar" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className="ddt-progress__fill" style={{ width: `${pct}%` }} />
      </div>
      <div className="ddt-progress__legend">
        <span>
          <span className="ddt-progress__dot ddt-progress__dot--pending" />
          {pending} pending
        </span>
        <span>
          <span className="ddt-progress__dot ddt-progress__dot--approved" />
          {approved} approved
        </span>
        <span>{total} total recorded</span>
      </div>
    </section>
  );
}
